import React, { useReducer } from "react";
import AnimatedSection from "@/components/animation/AnimatedSection/AnimatedSection";
import NewsCard from "@/components/NewsCard";
import { FETCH_ALL_ARTICLE_API } from "@/constants/apiEndpoints";
import { useFetch } from "@/utils/useAxios";
import { reducer } from "@/utils/commonUtils";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // ✅ import i18n hook

const initialState = {
  searchKeyword: "",
  filteredInfo: {},
  sorter: {},
};

const NewsPage = ({ history }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { i18n } = useTranslation();

  const {
    fetchedData: articleFetchedData,
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_ARTICLE_API}`, state);

  const lang = i18n.language === "id" ? "id" : "en";
  const data = articleFetchedData?.data?.data || [];

  return (
    <div>
      <AnimatedSection>
        <section className="w-full max-w-6xl mx-auto px-6 sm:px-12 py-8">
          <h1 className="text-3xl sm:text-4xl font-bold mb-8 text-[#101616]">
            Blogs
          </h1>
          {loading && <div>Loading...</div>}{" "}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
            {data.map((item, idx) => (
              <Link
                to={`/${lang}/blogs/${item._id}`}
                key={item._id}
                style={{ textDecoration: "none" }}
              >
                <NewsCard
                  key={item.title + idx}
                  img={item.imagePath}
                  title={item.title}
                  desc={item.desc}
                />
              </Link>
            ))}
          </div>
        </section>
      </AnimatedSection>
    </div>
  );
};

export default NewsPage;
